import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);
/** 主界面路由配置 */
export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: '用数据支撑决策'
			}
		},
		{
			path: '/voucher',
			name: 'Voucher',
			component: () => import('./views/voucher/Index'),
			meta: {
				title: '凭证列表'
			}
		},
		{
			path: '/voucher/list',
			name: 'VoucherList',
			component: () => import('./views/voucher/VoucherList'),
			meta: {
				title: '凭证列表'
			}
		},
		{
			path: '/voucher/form/:voucherId(\\d+)?',
			name: 'VoucherForm',
			component: () => import('./views/voucher/VoucherForm'),
			props: true,
			meta: {
				title: '凭证信息'
			}
		},
		{
			path: '/check-out',
			name: 'CheckOut',
			component: () => import('./views/checkout/Index'),
			children: [
				{
					path: 'list',
					name: 'CheckList',
					component: () => import('./views/checkout/CheckList'),
					meta: {
						title: '结转'
					}
				},
				{
					path: 'un-check',
					name: 'UnCheckOut',
					component: () => import('./views/checkout/UnCheckOut'),
					meta: {
						title: '反结账'
					}
				}, {
					path: 'carry-forward/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'CarryForward',
					props: true,
					component: () => import('./views/checkout/CarryForward'),
					meta: {
						title: '月末结转'
					}
				}, {
					path: 'check/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'Check',
					props: true,
					component: () => import('./views/checkout/Check'),
					meta: {
						title: '检查'
					}
				}
			]
		},

		{
			path: '/asset-class',
			name: 'AssetClass',
			component: () => import('./views/asset/AssetType.vue'),
			meta: {
				title: '资产类别'
			}
		},
		{
			path: '/asset-fixed',
			name: 'FixedAssets',
			component: () => import('./views/asset/FixedAssets.vue'),
			meta: {
				title: '固定资产管理'
			}
		},
		{
			path: '/asset-detail',
			name: 'AssetDetails',
			component: () => import('./views/asset/AssetDetails.vue'),
			meta: {
				title: '资产调出明细'
			}
		},
		{
			path: '/accrue-depreciation',
			name: 'AccrueDepreciation',
			component: () => import('./views/asset/AccrueDepreciation.vue'),
			meta: {
				title: '计提折旧'
			}
		},

		{
			path: '/account',
			name: 'Account',
			component: () => import('./views/setting/Account'),
			meta: {
				title: '账套'
			}
		},
		{
			path: '/subject',
			name: 'Subject',
			component: () => import('./views/setting/Subject'),
			meta: {
				title: '科目'
			}
		},
		{
			path: '/initial',
			name: 'Initial',
			component: () => import('./views/setting/Initial'),
			meta: {
				title: '初始余额'
			}
		},
		{
			path: '/voucher-word',
			name: 'VoucherWord',
			component: () => import('./views/setting/VoucherWord'),
			meta: {
				title: '凭证字'
			}
		},
		{
			path: '/currency',
			name: 'Currency',
			component: () => import('./views/setting/Currency'),
			meta: {
				title: '币别'
			}
		},
		{
			path: '/assisting-accounting',
			name: 'AssistingAccounting',
			component: () => import('./views/setting/AssistingAccounting'),
			meta: {
				title: '辅助核算'
			},
			children: [
				{
					path: 'accounting-category',
					name: 'AccountingCategory',
					component: () => import('./views/setting/AssistingAccounting/AccountingCategory'),
					meta: {
						title: '辅助核算类别'
					}
				},
				{
					path: 'custom/:id(\\d+)',
					name: 'CategoryCustom',
					component: () => import('./views/setting/AssistingAccounting/CategoryCustom'),
					props: true,
					meta: {
						title: '自定类别'
					}
				}
			]
		},
		{
			path: '/template',
			component: () => import('./views/setting/template/Index'),
			meta: {
				title: '模板管理'
			},
			children: [{
				path: 'manager',
				name: 'TemplateManager',
				component: () => import('./views/setting/template/TemplateManager'),
				meta: {
					title: '模板管理'
				}
			}, {
				path: 'design/:templateId(\\d+)?',
				name: 'TemplateDesign',
				component: () => import('./views/setting/template/TemplateDesign'),
				props: true,
				meta: {
					title: '模板设计'
				}
			}]
		},
		{
			path: '/permission-setting',
			name: 'PermissionSetting',
			component: () => import('./views/setting/PermissionSetting'),
			meta: {
				title: '权限设置'
			}
		},
		{
			path: '/personal',
			name: 'Personal',
			component: () => import('./views/personal/Index'),
			meta: {
				title: '个人设置'
			},
			children: [
				{
					path: 'personal-setting',
					name: 'PersonalSetting',
					component: () => import('./views/personal/PersonalSetting'),
					meta: {
						title: '个人设置'
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: () => import('./views/personal/ChangePassword'),
					meta: {
						title: '修改密码'
					}
				},
				{
					path: 'change-phone-number',
					name: 'ChangePhoneNumber',
					component: () => import('./views/personal/ChangePhoneNumber'),
					meta: {
						title: '修改手机'
					}
				},
				{
					path: 'binding-webchat',
					name: 'BindingWebchat',
					component: () => import('./views/personal/BindingWebchat'),
					meta: {
						title: '绑定微信'
					}
				}
			]
		},
		{
			path: '/account-book/detailed',
			name: 'DetailedAccounts',
			component: () => import('./views/accountbook/DetailedAccounts'),
			meta: {
				title: '明细账'
			}
		},
		{
			path: '/account-book/general-ledger',
			name: 'GeneralLedger',
			component: () => import('./views/accountbook/GeneralLedger'),
			meta: {
				title: '总账'
			}
		},
		{
			path: '/account-book/subject-balance',
			name: 'SubjectBalance',
			component: () => import('./views/accountbook/SubjectBalance'),
			meta: {
				title: '科目余额'
			}
		},
		// {
		// 	path: '/account-book/subject-zichanfuzhai',
		// 	name: 'ZiChanFuZhai',
		// 	component: () => import('./views/accountbook/ZiChanFuZhai.vue'),
		// 	meta: {
		// 		title: '资产负债表'
		// 	}
		// },
		{
			path: '/account-book/subject-zichanfuzhai',
			name: 'XinZiChanFuZhai',
			component: () => import('./views/accountbook/XinZiChanFuZhai.vue'),
			meta: {
				title: '资产负债表'
			}
		},
		{
			path: '/account-book/subject-summary',
			name: 'SubjectSummary',
			component: () => import('./views/accountbook/SubjectSummary'),
			meta: {
				title: '科目汇总'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-balance',
			name: 'AuxiliaryAccountingBalance',
			component: () => import('./views/accountbook/AuxiliaryAccountingBalance'),
			meta: {
				title: '辅助核算余额'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-detail',
			name: 'AuxiliaryAccountingDetail',
			component: () => import('./views/accountbook/AuxiliaryAccountingDetail'),
			meta: {
				title: '辅助核算明细账'
			}
		},
		{
			path: '/account-book/auxiliary-subject-balance',
			name: 'AuxiliarySubjectBalance',
			component: () => import('./views/accountbook/AuxiliarySubjectBalance'),
			meta: {
				title: '核算科目余额'
			}
		},
		{
			path: '/account-book/auxiliary-subject-detail',
			name: 'AuxiliarySubjectDetail',
			component: () => import('./views/accountbook/AuxiliarySubjectDetail'),
			meta: {
				title: '核算科目明细账'
			}
		},
		{
			path: '/report',
			name: 'ReportList',
			component: () => import('./views/report/ReportList'),
			meta: {
				title: '报表'
			}
		},
		{
			path: '/report/aggrandising',
			name: 'Aggrandising',
			props: true,
			component: () => import('./views/huizong/JingYingDian.vue'),
			meta: {
				title: '经营部门'
			}
		},
		{
			path: '/report/gigalumen',
			name: 'Gigalumen',
			props: true,
			component: () => import('./views/huizong/GuanLiDian.vue'),
			meta: {
				title: '管理部门'
			}
		},
		{
			path: '/report/FenPeiFeiYong',
			name: 'FenPeiFeiYong',
			props: true,
			component: () => import('./views/huizong/FenPeiFeiYong.vue'),
			meta: {
				title: '分配费用·'
			}
		},
		{
			path: '/report/guanlicunkuan',
			name: 'QzGuanLick',
			props: true,
			component: () => import('./views/huizong/QzGuanLick.vue'),
			meta: {
				title: '管理存款数据'
			}
		},
		{
			path: '/report/guanlixianjin',
			name: 'QzGuanLixj',
			props: true,
			component: () => import('./views/huizong/QzGuanLixj.vue'),
			meta: {
				title: '管理现金数据'
			}
		},
		{
			path: '/report/jingyingcunkuan',
			name: 'QzJingYingck',
			props: true,
			component: () => import('./views/huizong/QzJingYingck.vue'),
			meta: {
				title: '经营存款数据'
			}
		},
		{
			path: '/report/jingyingxianjin',
			name: 'QzJingYingxj',
			props: true,
			component: () => import('./views/huizong/QzJingYingxj.vue'),
			meta: {
				title: '经营存款数据'
			}
		},
		{
			path: '/report/tongbujingying',
			name: 'TbJingYing',
			props: true,
			component: () => import('./views/huizong/TbJingYing.vue'),
			meta: {
				title: '同步经营'
			}
		},
		{
			path: '/report/tongbuguanli',
			name: 'TbGuanLi',
			props: true,
			component: () => import('./views/huizong/TbGuanLi.vue'),
			meta: {
				title: '同步管理'
			}
		},
		{
			path: '/report/yucejingying',
			name: 'YcJingYing',
			props: true,
			component: () => import('./views/huizong/YcJingYing.vue'),
			meta: {
				title: '预测经营'
			}
		},
		{
			path: '/report/yuceguanli',
			name: 'YcGuanLi',
			props: true,
			component: () => import('./views/huizong/YcGuanLi.vue'),
			meta: {
				title: '预测管理'
			}
		},
		{
			path: '/report/baunziChanFuZhai',
			name: 'BaoCunZiChanFuZhai',
			props: true,
			component: () => import('./views/huizong/BaoCunZiChanFuZhai.vue'),
			meta: {
				title: '资产负债表'
			}
		},
		{
			path: '/report/huizichanfuzhai',
			name: 'HuiZiChanFuZhai',
			props: true,
			component: () => import('./views/huizong/HuiZiChanFuZhai.vue'),
			meta: {
				title: '资产负债表'
			}
		},

		{
			path: '/city-manager',
			name: 'CityManager',
			component: () => import('./views/report/CityManager'),
			meta: {
				title: '城市经理'
			},
			children: [
				{
					path: 'list',
					name: 'CityManagerList',
					component: () => import('./views/report/CityManager/CityManagerList'),
					meta: {
						title: '城市经理'
					}
				},
				{
					path: 'department',
					name: 'CityManagerDepartment',
					component: () => import('./views/report/CityManager/CityManagerDepartment'),
					meta: {
						title: '部门归属'
					}
				},
				{
					path: 'expense',
					name: 'CityManagerExpense',
					component: () => import('./views/report/CityManager/CityManagerExpense'),
					meta: {
						title: '经营费用'
					}
				}
			]
		},
		{
			path: '/report/view/:reportId(\\d+)',
			name: 'ReportView',
			props: true,
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '报表数据'
			}
		},
		{
			path: '/report/template',
			name: 'ReportTemplate',
			component: () => import('./views/report/template/TemplateList'),
			meta: {
				title: '报表模板'
			}
		},
		{
			path: '/report/template/form/:templateId(\\d+)',
			name: 'TemplateForm',
			props: true,
			component: () => import('./views/report/template/TemplateForm'),
			meta: {
				title: '模板编辑'
			}
		},
		{
			path: '/report/balance-statement',
			name: 'BalanceStatement',
			props: true,
			component: () => import('./views/report/BalanceStatement.vue'),
			meta: {
				title: '资产负债'
			}
		},
		{
			path: '/report/cash-flow-statement',
			name: 'CashFlowStatement',
			props: true,
			component: () => import('./views/report/CashFlowStatement.vue'),
			meta: {
				title: '现金流量表'
			}
		},
		{
			path: '/report/org-profit-statement',
			name: 'OrgProfitStatement',
			props: true,
			component: () => import('./views/report/OrgProfitStatement.vue'),
			meta: {
				title: '营业利润表'
			}
		},
		{
			path: '/report/profit-statement',
			name: 'ProfitStatement',
			props: true,
			component: () => import('./views/report/ProfitStatement.vue'),
			meta: {
				title: '收入利润表'
			}
		},
		{
			path: '/report/year-profit-statement',
			name: 'YearProfitStatement',
			props: true,
			component: () => import('./views/report/YearProfitStatement.vue'),
			meta: {
				title: '年度利润表'
			}
		},
		{
			path: '/report/grant-org',
			name: 'GrantOrg',
			props: true,
			component: () => import('./views/report/template/GrantOrg.vue'),
			meta: {
				title: '组织授权'
			}
		},
		{
			path: '/report/organization',
			name: 'Organization',
			props: true,
			component: () => import('./views/setting/Organization.vue'),
			meta: {
				title: '组织机构'
			}
		},
		{
			path: '/report/jxc-setting',
			name: 'JxcSetting',
			props: true,
			component: () => import('./views/setting/JxcSetting.vue'),
			meta: {
				title: '进销存设置'
			}
		},



	]
});
